var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoRoundedDarkScan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_rounded_dark_scan",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_26170",
    "data-name": "Tracciato 26170",
    d: "M30,0A30,30,0,1,1,0,30,30,30,0,0,1,30,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_19677",
    "data-name": "Raggruppa 19677",
    transform: "translate(-1702.038 -251.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_19429",
    "data-name": "Raggruppa 19429",
    transform: "translate(1720.468 269.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_26170-2",
    "data-name": "Tracciato 26170",
    d: "M-16130.546-11114.295a.586.586,0,0,1-.587-.587v-8.177h7.939a.588.588,0,0,1,.587.587.588.588,0,0,1-.587.588h-6.764v7A.587.587,0,0,1-16130.546-11114.295Z",
    transform: "translate(16131.133 11123.127)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_26171",
    "data-name": "Tracciato 26171",
    d: "M-16123.194-11114.295a.586.586,0,0,1-.588-.587v-7h-6.763a.587.587,0,0,1-.589-.588.587.587,0,0,1,.589-.587h7.939v8.177A.587.587,0,0,1-16123.194-11114.295Z",
    transform: "translate(16146.414 11123.059)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_26172",
    "data-name": "Tracciato 26172",
    d: "M-16123.193-11114.295h-7.939v-8.177a.587.587,0,0,1,.587-.587.588.588,0,0,1,.589.587v7h6.764a.588.588,0,0,1,.587.589A.587.587,0,0,1-16123.193-11114.295Z",
    transform: "translate(16131.133 11137.231)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_26173",
    "data-name": "Tracciato 26173",
    d: "M-16122.605-11114.295h-7.939a.586.586,0,0,1-.589-.587.588.588,0,0,1,.589-.589h6.763v-7a.588.588,0,0,1,.588-.587.588.588,0,0,1,.589.587Z",
    transform: "translate(16146.414 11137.161)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Linea_3104",
    "data-name": "Linea 3104",
    d: "M26.508.675H.075A.581.581,0,0,1-.5.088.581.581,0,0,1,.075-.5H26.508a.581.581,0,0,1,.575.588A.581.581,0,0,1,26.508.675Z",
    transform: "translate(1718.978 281.088)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRoundedDarkScan);
export default __webpack_public_path__ + "static/media/ico_rounded_dark_scan.159d1232fb98d584cbc69bab0102bdfb.svg";
export { ForwardRef as ReactComponent };